import React from "react";
import {TopMenuAdmin} from "@/components/layouts/top-menu-admin";
import {UserMenu} from "@/components/layouts/user-menu";

export function Navbar({className, ...props}) {
    return (
        <>
            {/*{*/}
            {/*    isInstAdmin ? <TopMenuAdmin/> : <TopMenuSimulate/>*/}
            {/*}*/}

            <TopMenuAdmin/>

            {/*<TopMenuAdmin/>*/}
            <div className={'flex flex-1 items-center justify-between space-x-2 md:justify-end sm:justify-end'}>
                {/*{*/}
                {/*    auth.user.isadmin == 1 && <InstitutionDropdown/>*/}
                {/*}*/}
                <UserMenu/>
            </div>
        </>

    );
}
